// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"7a99f6df","247":"00008aa4","422":"3682ea63","627":"ac3173b5","653":"7f113077","834":"dd59bf2f","867":"f961cfb8","923":"ac2458ce","938":"1375b510"}[chunkId] + ".chunk.js";
};